var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHiddenEyeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 15.5,
    stroke: "#DFE1E6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 16C8.75199 14.4952 9.89718 13.2318 11.309 12.3494C12.7208 11.467 14.3443 11 16 11C17.6557 11 19.2792 11.467 20.691 12.3494C22.1028 13.2318 23.248 14.4952 24 16C23.248 17.5048 22.1028 18.7682 20.691 19.6506C19.2792 20.533 17.6557 21 16 21C14.3443 21 12.7208 20.533 11.309 19.6506C9.89718 18.7682 8.75199 17.5048 8 16ZM16 19.3311C16.866 19.3311 17.6966 18.9802 18.3089 18.3555C18.9213 17.7307 19.2653 16.8835 19.2653 16C19.2653 15.1165 18.9213 14.2693 18.3089 13.6445C17.6966 13.0198 16.866 12.6689 16 12.6689C15.134 12.6689 14.3034 13.0198 13.6911 13.6445C13.0787 14.2693 12.7347 15.1165 12.7347 16C12.7347 16.8835 13.0787 17.7307 13.6911 18.3555C14.3034 18.9802 15.134 19.3311 16 19.3311ZM16 17.6656C15.567 17.6656 15.1517 17.4901 14.8455 17.1777C14.5394 16.8654 14.3673 16.4417 14.3673 16C14.3673 15.5583 14.5394 15.1346 14.8455 14.8223C15.1517 14.5099 15.567 14.3344 16 14.3344C16.433 14.3344 16.8483 14.5099 17.1545 14.8223C17.4606 15.1346 17.6327 15.5583 17.6327 16C17.6327 16.4417 17.4606 16.8654 17.1545 17.1777C16.8483 17.4901 16.433 17.6656 16 17.6656Z",
    fill: "#5E6C84"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7344 2L6.00071 30.1978",
    stroke: "#5E6C84",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7344 2L6.00071 30.1978",
    stroke: "white",
    strokeOpacity: 0.2,
    strokeWidth: 3,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHiddenEyeIcon);
export default __webpack_public_path__ + "static/media/hidden_eye_icon.09a4575d60b7a021561664dd7e0d53e2.svg";
export { ForwardRef as ReactComponent };